<template>
	<div id="app" style="height: 100%;overflow: hidden;">
		<div class="header" style="height: 50px;background-color:#4980b5 ;">
			<div class="middle-row between" style="height:50px;width:100%;background-color: ;">
				<h4 class="clickable" style="padding-left: 20px;"><b style="color: white;" @click="showMain(-1)">淮北市相山区生态环境分局餐饮油烟防治精细化管控服务平台</b></h4>
				<div style="height: 100%;" class="middle-row">
					<button disabled="disabled" class="btn btn-default" style="margin-right: 10px;"><i class="fa fa-user-circle" style="color: green;">&nbsp;{{login.usertype}}</i></button>
					<button style="margin-right: 20px;" @click="signOut()" class="btn btn-default"><i class="fa fa-sign-out">&nbsp;注销</i></button>
				</div>
			</div>
		</div>
		<div class="body">
			<div class="bodyleft">
				<div class="panel-group" id="panel-728285">
					<div class="panel panel-default">
						<div class="panel-heading">
							<a class="panel-title"  @click="switchBG(1)" :class="bg==1?'bg-active':''" data-toggle="collapse" data-parent="#panel-728285" href="#panel-element-1"><i class="fa fa-dashboard"></i>
								&nbsp;&nbsp;监控中心</a>
						</div>
						<div id="panel-element-1" class="panel-collapse collapse">
							<div class="panel-body"  @click="showMain(0)">
								<router-link :class="index==0?'active-self':''" class="likea" to="/restaurant">餐饮油烟排放 <span class="badge bg-self green">{{merchantTypes.餐饮油烟排放}}</span></router-link>
							</div>
							<div class="panel-body" @click="showMain(1)">
								<router-link :class="index==1?'active-self':''" class="likea" to="/advertisement">VOCs排放 <span class="badge bg-self green">{{merchantTypes.VOCS排放}}</span></router-link>
							</div>
							<div class="panel-body" @click="showMain(2)">
								<router-link :class="index==2?'active-self':''" class="likea" to="/dust">工地扬尘 <span class="badge bg-self green">{{merchantTypes.工地扬尘}}</span></router-link>
							</div>
							<div class="panel-body"  @click="showMain(3)">
								<router-link :class="index==3?'active-self':''" class="likea" to="/carrepair">工业企业废气 <span class="badge bg-self green">{{merchantTypes.工业企业废气}}</span></router-link>
							</div>
						</div>
					</div>
					<div class="panel panel-default">
						<div class="panel-heading">
							<a class="panel-title"  @click="switchBG(2)" :class="bg==2?'bg-active':''" data-toggle="collapse" data-parent="#panel-728285" href="#panel-element-2"><i class="fa fa-database"></i>
								&nbsp;&nbsp;数据中心</a>
						</div>
						<div id="panel-element-2" class="panel-collapse collapse">
							<div class="panel-body" @click="showMain(7)">
								<router-link :class="index==7?'active-self':''" class="likea" to="/detail">历史数据查询</router-link>
							</div>
							<div class="panel-body"  @click="showMain(8)">
								<router-link :class="index==8?'active-self':''" class="likea" to="/detail2">详细数据查询</router-link>
							</div>
							<div class="panel-body"  @click="showMain(18)">
								<router-link :class="index==18?'active-self':''" class="likea" to="/dailyReport">日报中心</router-link>
							</div>
						</div>
					</div>
					<div class="panel panel-default">
						<div class="panel-heading">
							<a class="panel-title"  @click="switchBG(3)" :class="bg==3?'bg-active':''" data-toggle="collapse" data-parent="#panel-728285" href="#panel-element-3"><i class="fa fa-briefcase"></i>
								&nbsp;&nbsp;事件中心</a>
						</div>
						<div id="panel-element-3" class="panel-collapse collapse" :class="index>=9&&index<=10||index==19?'in':''">
							<div class="panel-body" @click="showMain(9)">
								<router-link :class="index==9?'active-self':''" class="likea" to="/event">告警事件<span v-if="untreated>0" class="badge bg-red">{{untreated}}</span></router-link>
							</div>
							<div class="panel-body" @click="showMain(19)">
								<router-link :class="index==19?'active-self':''" class="likea" to="/event2">街道事件</router-link>
							</div>
							<div class="panel-body" @click="showMain(10)">
								<router-link :class="index==10?'active-self':''" class="likea" to="/eventlist">事件列表</router-link>
							</div>
							<!-- <div class="panel-body" @click="showMain(20)">
								<router-link :class="index==20?'active-self':''" class="likea" to="/eventDaily">事件趋势</router-link>
							</div> -->
						</div>
					</div>
					<div class="panel panel-default">
						<div class="panel-heading">
							<a class="panel-title"  @click="switchBG(4)" :class="bg==4?'bg-active':''" data-toggle="collapse" data-parent="#panel-728285" href="#panel-element-4"><i class="fa fa-television"></i>
								&nbsp;&nbsp;控制中心</a>
						</div>
						<div id="panel-element-4" class="panel-collapse collapse">
							<div v-if="isControll || isAdmin" class="panel-body"  @click="showMain(11)">
								<router-link class="likea" :class="index==11?'active-self':''" to="/addequ">新增监测设备</router-link>
							</div>
							<div v-if="isControll || isAdmin" class="panel-body" @click="showMain(12)">
								<router-link :class="index==12?'active-self':''" class="likea" to="/editequ">设备管理</router-link>
							</div>
							<div class="panel-body"  @click="showMain(13)">
								<router-link :class="index==13?'active-self':''" class="likea" to="/edituser">修改个人信息</router-link>
							</div>
							<div v-if="isAdmin" class="panel-body"  @click="showMain(14)">
								<router-link :class="index==14?'active-self':''" class="likea" to="/adduser">新增用户</router-link>
							</div>
							<div v-if="isAdmin" class="panel-body"  @click="showMain(15)">
								<router-link :class="index==15?'active-self':''" class="likea" to="/admin">用户管理</router-link>
							</div>
							<div v-if="isAdmin" class="panel-body"  @click="showMain(16)">
								<router-link :class="index==16?'active-self':''" class="likea" to="/eventsetting">阈值设置</router-link>
							</div>
						</div>
					</div>
					<div class="panel panel-default">
						<div class="panel-heading">
							<a class="panel-title"  @click="switchBG(5)" :class="bg==5?'bg-active':''" data-toggle="collapse" data-parent="#panel-728285" href="#panel-element-5"><i class="fa fa-align-justify"></i>
								&nbsp;&nbsp;小程序管理</a>
						</div>
						<div id="panel-element-5" class="panel-collapse collapse">
							<div v-if="isControll ||isAdmin" class="panel-body"  @click="showMain(18)">
								<router-link :class="index==18?'active-self':''" class="likea" to="/addMiniuser">新增小程序用户</router-link>
							</div>
							<div v-if="isControll ||isAdmin" class="panel-body"  @click="showMain(19)">
								<router-link :class="index==19?'active-self':''" class="likea" to="/miniadmin">小程序用户管理</router-link>
							</div>
							<div class="panel-body"  @click="showMain(17)">
								<router-link :class="index==17?'active-self':''" class="likea" to="/equlist">商户列表</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="bodyright" style="overflow: hidden;">
				<div id="routermain" class="router" style="padding: 10px;overflow:auto;">
						<Home ref='home' v-show="!showrouter" msg="淮北市相山区生态环境分局餐饮油烟防治精细化管控服务平台" />
						<router-view v-show="showrouter" @toDetail="toDetail"></router-view>
				</div>
				<div class="foot middle-row center">
					<i class="fa fa-copyright">安徽盛世能辰环境工程有限公司 2025</i>&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/" target="_blank">皖ICP备2025089511号</a>
				</div>
			</div>
		</div>
		<div class="modal fade" data-backdrop="static" data-keyboard="false" id="loginModal" tabindex="-1" role="dialog"
		 aria-labelledby="myModalLabel" aria-hidden="true">
			<div class="modal-dialog" style="width: 100%;height: 100%;margin: 0px;">
				<div class="modal-content login middle-row end" style="width: 100%;height: 100%;">
					<div style="width:30%;padding:40px 20px;background-color: white;border-radius: 20px;opacity: 0.92;" class="middle-column start">
						<div style="margin-bottom: 30px;">
							<h2 style="margin-bottom: 20px !important;"><b>淮北市相山区</b></h2>
							<h3><b>污染物防治管理系统</b></h3>
						</div>
						<div style="width: 70%" id="newModel" >
							<div class="input-group" style="margin-bottom: 20px;">
								<span class="input-group-addon">用户名称</span>
								<input type="text" v-model="login.username" class="form-control">
							</div>
							<div class="input-group" style="margin-bottom: 20px;">
								<span class="input-group-addon">登录密码</span>
								<input type="password" v-model="login.password" class="form-control">
							</div>
							<div class=" middle-row center" style="margin-bottom: 20px;">
								<input type="text" v-model="verify" placeholder="请输入验证码" @keydown.enter="doLogin"  class="form-control" style="height: 38px;">
								<div @click="refreshCode">
									<Sidentify :identifyCode='identifyCode'></Sidentify>
								</div>
							</div>
							<div class="middle-row around" style="width:100%;margin-top: 20px;">
								<button type="button" class="btn btn-primary" @click="doLogin">登录</button>
								<button type="button" class="btn btn-default">取消</button>
							</div>
						</div>
					</div>
					<div style="width:20%;height: 50%;"></div>
				</div><!-- /.modal-content -->
			</div><!-- /.modal -->
		</div>
		<div id="warning" class="middle-column around" style="position: fixed;right:30px;bottom:-300px;width: 200px;height:300px;background-color: white;z-index: 100;border: 1px solid grey;">
			<h4 style="padding: 10px;"><i class="fa fa-4x fa-warning red"></i></h4>
			<h2 style="padding: 10px;">监测超标!</h2>
			<h4 style="padding: 10px;color: red;">发现监测值超标，请前往事件中心查看！</h4>
			<div class="middle-row around" style="padding: 10px;width: 100%;">
				<button class="btn btn-default" @click="closeWarning">关闭</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Home from './components/home.vue'
	import Sidentify from "./components/identify.vue"
	import {
		util
	} from '../static/util.js'
	export default {
		name: 'app',
		data() {
			return {
				showmain: true,
				showrouter: false,
				index: -1,
				login: {
					username: '',
					password: '',
					userdp: '',
					usertype: '未登录'
				},
				isAdmin: false,
				isControll: false,
				auth: '',
				bg:1,
				merchantTypes:{},
				untreated:0,//未处理事件总数,
				identifyCode:'3214',
				verify:''
			}
		},
		components: {
			Home,Sidentify
		},
		methods: {
			signOut: function() {
				if (confirm("确定退出当前账户？")) {
					window.localStorage.removeItem('auth');
					window.localStorage.removeItem('time');
					window.localStorage.removeItem('kly');
					window.localStorage.removeItem('_id');
					this.login.usertype = '请登录';
					window.location.href = "https://youyan.woledo.com";
				}
			},
			showMain: function(a) {
				if (a == -1) {
					window.location.href = "https://youyan.woledo.com";
				} else {
					this.showmain = false;
					this.showrouter = true;
					this.index = a;
				}
			},
			toDetail: function(obj) {
				this.showMain(8);
				this.$router.push({
					path: '/detail2',
					query: {
						mer: obj
					}
				});
				$("#panel-element-1").collapse('hide');
				$("#panel-element-2").collapse('show');
			},
			doLogin: function() {
				//console.log(this.login)
				if (this.verify == this.identifyCode) {
					this.$http.post(this.GLOBAL.base + 'doLogin', this.login, {
						emulateJSON: true
					}).then(function(msg) {
						console.log(msg.header)
						this.login = msg.body
						if (this.login.username && this.login.token) {
							$("#loginModal").modal("hide");
							this.auth = 'success';
							window.localStorage.setItem('token',this.login.token);
							window.localStorage.setItem('_id',this.login.id);
							window.localStorage.setItem("auth", 'success');
							window.localStorage.setItem("time", new Date().getTime());
							window.localStorage.setItem('kly', util.switchPermission(this.login.usertype));
							if (this.login.usertype == '高级管理员') {
								this.isAdmin = 'true';
								this.isControll = 'true';
							} else if (this.login.usertype == '普通管理员') {
								this.isControll = 'true';
							}
							this.$http.get(this.GLOBAL.base+'getMerchantTypeCount').then(function(msg) {
								this.merchantTypes=msg.body;
							});
							setInterval(function() {
								that.$http.get(that.GLOBAL.base+'getEventStateCount').then(function(msg) {
									if(that.untreated < msg.body.untreated){
										$("#warning").animate({bottom:"0px"});
									}
									that.untreated=msg.body.untreated;
								})
							}, 20000)
							
							this.$http.get(this.GLOBAL.base+'getEventStateCount').then(function(msg) {
								this.untreated=msg.body.untreated;
							})
							this.$refs.home.initData();
						} else {
							alert("用户名或者密码错误")
						}
					})
				} else{
					alert("验证错误")
				}
			},
			switchBG:function(n) {
				this.bg = n;
			},
			closeWarning:function() {
				$("#warning").animate({bottom:"-300px"});
			},
			refreshCode:function  () {
				this.identifyCode  = Math.random().toString(36).substr(2).slice(1,5);
			},
		},
		mounted() {
			var that = this;
			
			this.GLOBAL.bodyHeight = document.body.clientHeight-100;

			this.auth = window.localStorage.getItem('auth');
			if (this.auth == "success") {
				var oldtime = window.localStorage.getItem("time");
				var nowtime = new Date().getTime();
				if (parseInt(nowtime) - parseInt(oldtime) >= 1296000000) {
					alert("登录过期，请重新登录")
					$("#loginModal").modal("show");
				} else {
					var id = window.localStorage.getItem("_id");
					this.$http.get(this.GLOBAL.base+'updateLoginLog',{params:{id:id}})
					$("#loginModal").modal("hide");
				}
			} else {
				$("#loginModal").modal("show");
			}
			var user = window.localStorage.getItem('kly');
			if (user) {
				var str = util.switchUser(user);
				this.login.usertype = str;
				if (this.login.usertype == '高级管理员') {
					this.isAdmin = 'true';
					this.isControll = 'true';
				} else if (this.login.usertype == '普通管理员') {
					this.isControll = 'true';
				}
			} else {
				this.login.usertype = '请登录';
			}
			setInterval(function() {
				if (that.auth != "success") {
					$("#loginModal").modal("show");
				}
			}, 30000)
			setInterval(function(){
				let target = document.getElementById("newModel");
				if(!target){
					location.reload();
				}
			},1000);
			this.refreshCode();
			this.GLOBAL.rightheight = document.getElementById("routermain").clientHeight-20;
		},

	}
</script>

<style>
	.container {
		width: 100%;
	}

	.navbar {
		margin-bottom: 10px;
	}

	.likea {
		display: block;
		height: 50px;
		width: 100%;
		line-height: 50px;
		color: black;
		font-size: 15px;
		background-color:  #262d33;
	}

	.input-group-addon {
		padding: 6px !important;
	}

	a {
		text-decoration: none !important;
	}

	.likea:active {
		color: white !important;
	}

	.active-self {
		border-left: 3px solid white;
		margin-left: -3px;
		color: white !important;
		background-color: #414d58;
	}

	.active-a {
		color: white !important;
	}

	.panel-body {
		padding: 0px;
	}

	.modal.fade.in {
		top: 50px;
		bottom: 50px;
		left: 150px;
		right: 150px;
	}

	.disa {
		color: gray !important;
	}

	.disa:hover {
		cursor: -ms-none;
	}

	.login {
		background-image: url(../static/images/bg.jpg);
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.clickable:hover {
		cursor: pointer;
	}

	.bodyleft {
		width: 15%;
		height: 100%;
		background-color: #262d33;
	}

	.bodyright {
		width: 85%;
		height: 100%;
		background-color: #efefef;
		position: relative;
	}

	.foot {
		position: fixed;
		bottom: 0px;
		left: 15%;
		right: 0px;
		height: 50px;
		background-color: white;
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		height: 100%;
		position: relative;
	}

	html,
	body {
		height: 100%;
		margin: 0px;
	}

	.header {
		height: 50px;
		width: 100%;
	}

	.router {
		position: absolute;
		top: 0px;
		bottom: 50px;
		left: 0px;
		right: 0px;
	}

	.body {
		position: absolute;
		top: 50px;
		bottom: 0px;
		left: 0px;
		right: 0px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	
	.panel-group .panel+.panel {
		margin: 0px;
	}
	
	.panel-group .panel{
		border-radius: 0px;
	}
	
	.panel{
		border: 0px;
	}
	
	.panel a:hover{
		color: white !important;
		background-color: #414d58;
	}
	
	a.bg-active:hover{
		background-color: #6194c1;
		color: white !important;
		font-family: '微软雅黑';
	}
	
	.panel-default>.panel-heading {
		background-color: #262d33;
		border-color: #262d33;
		color: #b5b5b5;
	}
		
	.panel-heading{
		border-radius: 0px !important;
		padding: 0px;
	}
	.panel a{
		display: inline-block;
		width: 100%;
		height: 50px;
		line-height: 50px;
		font-family: '微软雅黑';
		color: #b5b5b5;
	}
	
	.bg-active{
		background-color: #6194c1;
		color: white !important;
		font-family: '微软雅黑';
	}
	
	.panel-body{
		border: 0px !important;
	}
	
	.s-canvas{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
</style>
